import React from "react";

const SixCareersCapitalism = () => {
  return (
    <section className="events-page-landing-section events-page-landing-section-space events-page-careers-section-build">
      <div className="events6ix-layout-page-middle">
        <div className="events-page-careers-section-build-row">
          <div className="events-page-careers-section-build-content">
            <div className="events-page-careers-section-header">
              <div className="events-page-careers-section-header-heading">
                Our Operating Principles
              </div>
            </div>
          </div>

          <div className="events-page-careers-section-build-content">
            <div className="events-page-careers-section-build-content-row">
              <div className="events-page-careers-section-build-content-row-heading">
                Craft & Mastery
              </div>
              <div className="events-page-careers-section-build-content-row-text">
                We believe in honing our skills to perfection, constantly
                pushing the boundaries of what's possible. At 6ix, we're
                craftspeople who take pride in building elegant solutions to
                complex problems.
              </div>
            </div>

            <div className="events-page-careers-section-build-content-row">
              <div className="events-page-careers-section-build-content-row-heading">
                Urgency & Intentionality
              </div>
              <div className="events-page-careers-section-build-content-row-text">
                In a fast-moving market, we act with purpose and speed. Every
                decision is made with clear intent as we race to democratize
                global investment opportunities.
              </div>
            </div>

            <div className="events-page-careers-section-build-content-row">
              <div className="events-page-careers-section-build-content-row-heading">
                Energy & Curiosity
              </div>
              <div className="events-page-careers-section-build-content-row-text">
                We approach each day with enthusiasm and a thirst for knowledge,
                constantly asking "why" and "what if" to drive innovation and
                improvement.
              </div>
            </div>

            <div className="events-page-careers-section-build-content-row">
              <div className="events-page-careers-section-build-content-row-heading">
                Individual Responsibility
              </div>
              <div className="events-page-careers-section-build-content-row-text">
                Every team member is empowered to take ownership of their work
                and lead by example. We believe the best ideas can come from
                anywhere in the organization.
              </div>
            </div>
            <div className="events-page-careers-section-build-content-row">
              <div className="events-page-careers-section-build-content-row-heading">
                Impact & Vocation
              </div>
              <div className="events-page-careers-section-build-content-row-text">
                We view our work not just as a job, but as a calling to create
                meaningful change. Our purpose extends beyond profit to
                transform how the world invests.
              </div>
            </div>
            <div className="events-page-careers-section-build-content-row">
              <div className="events-page-careers-section-build-content-row-heading">
                Hard Work & Customer Obsession
              </div>
              <div className="events-page-careers-section-build-content-row-text">
                We're relentless in our pursuit of excellence, going the extra
                mile to ensure our platform delivers exceptional value to our
                users.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SixCareersCapitalism;
